import React from 'react'
import moment from 'moment/moment'
import {
  BtnContainer,
  Button,
  CardChevronBtn,
  CardContainer,
  CardWrapper,
  Dot,
  FlexContainer,
  LiveContainer,
  MinWidthSetter,
  NotesPoints,
  StageAndPrizeCardContainer,
  StageCardHeading,
  StageSubHeading,
  StageTable,
  VerticalCenterItems,
  Prize1Div,
  Prize2Div,
  Prize3Div,
  Prize4Div,
  RewardAmount,
  RewardNote,
  Trophy,
  AndImg,
  TrophyBottom,
  RewardNoteBottom,
  NumberOfWinners
} from '../style'
import ImportantNoteIcon from '../../../components/Images/ImportantNoteIcon'
import ChevronDown from '../../../components/Images/ChevronDown'
import Stage1 from '../images/trophy1.webp'
import Stage2 from '../images/trophy2.webp'
import Stage3 from '../images/trophy3.webp'
import Stage4 from '../images/trophy4.webp'
import Stage5 from '../images/trophy5.webp'
import Stage6 from '../images/trophy6.webp'
import Stage7 from '../images/trophy7.webp'
import Stage8 from '../images/trophy8.webp'
import Stage9 from '../images/trophy9.webp'
import Stage10 from '../images/trophy10.webp'
import and from '../images/and_symbol.svg'
import trophy1_bottom from '../images/trophy1_bottom.svg'
import trophy2_bottom from '../images/trophy2_bottom.svg'
import trophy3_bottom from '../images/trophy3_bottom.svg'
import trophy4_bottom from '../images/trophy4_bottom.svg'
import LinkOut from '../images/link.png'
import { handleNotionOrExternalLink } from '../../../lib/utils'
export default function StageContainer({
  handleJoinContestBtn,
  checkContestStatus,
  heading,
  toggleExtraInfoHandler,
  reward_notes,
  important_points,
  notes,
  sub_heading,
  result_date,
  min_words,
  end_date,
  sub_heading_hyperlink,
  imp_reward_notes,
  ...props
}) {
  const handleRewardNotes = () => {
    return reward_notes.split('\n')
  }
  const newRewardNotes = handleRewardNotes()
  const linearGradientArr = [ 
    'linear-gradient(270deg, #696eff 19.08%, #f8acff 78.16%)', 
    'linear-gradient(270deg, #595cff 19.08%, #c6f8ff 78.16%)', 
    'linear-gradient(270deg, #ef709b 19.08%, #fa9372 78.16%)',
    'linear-gradient(270deg, #bf0fff 19.08%, #cbff49 78.16%)',
    'linear-gradient(270deg, #40c9ff 19.08%, #e81cff 78.16%)',
    'linear-gradient(270deg, #ff5858 19.08%, #ffc8c8 78.16%)',
  ]
  const trophySrcArr = [Stage4,Stage5,Stage6,Stage7,Stage8, Stage9, Stage10]
  return (
    <StageAndPrizeCardContainer>
      <CardContainer backgroundColor="#F8F9FF">
        <CardWrapper>
          <StageCardHeading backgroundColor="#D7DBF5">
            {heading || ''}
          </StageCardHeading>
          <StageSubHeading>
            {sub_heading || ''}&nbsp;&nbsp;
            {sub_heading_hyperlink && <span onClick={() => handleNotionOrExternalLink(sub_heading_hyperlink)} style={{color: '#66cdf6', cursor: 'pointer'}}>click here <img src={LinkOut}/></span>}&nbsp;&nbsp;
            {/* {moment(end_date).format('Do MMM')} */}
            {/* &nbsp;&nbsp; */}
            <LiveContainer
              color={
                checkContestStatus(end_date) ? '#54b585' : 'var(--Punch500)'
              }
            >
              <Dot
                bgColor={
                  checkContestStatus(end_date) ? '#54b585' : 'var(--Punch500)'
                }
              />
              &nbsp;
              {checkContestStatus(end_date) ? 'LIVE' : 'ENDED'}
            </LiveContainer>
          </StageSubHeading>
          <StageTable>
            <tbody>
              <tr>
                <td>Last Date to complete {min_words / 1000}k words ⌛</td>
                <td>{moment(end_date).format('Do MMM')}</td>
              </tr>
              <tr>
                <td>Results on 🎉</td>
                <td>{moment(result_date).format('Do MMM')}</td>
              </tr>
            </tbody>
          </StageTable>
          <FlexContainer>
            <MinWidthSetter>
              <ImportantNoteIcon width={'34'} height={'34'} />
            </MinWidthSetter>
            <div>
              <NotesPoints>
                {important_points}
                <br />
                <p style={{ 'white-space': 'pre-wrap' }}>{notes}</p>
              </NotesPoints>
              <CardChevronBtn onClick={toggleExtraInfoHandler}>
                <ChevronDown width="24" height="24" fillOpacity="1" />
              </CardChevronBtn>
            </div>
          </FlexContainer>
        </CardWrapper>
        <VerticalCenterItems>
          <Prize1Div>
            <Trophy src={Stage1} />
            <TrophyBottom src={trophy1_bottom} />
            {props.winner1_no && <NumberOfWinners>x {`${props.winner1_no}`}</NumberOfWinners>}
            <div>
              <RewardAmount>{props.moneySymbol} {props.winner1_amount}</RewardAmount>
              <div style={{ display: 'flex' }}>
                <AndImg src={and} />
                <RewardNote>{props.winner1_reward_note}</RewardNote>
              </div>
            </div>
          </Prize1Div>
          <Prize2Div>
            <Trophy src={Stage2} />
            <TrophyBottom src={trophy2_bottom} />
            {props.winner2_no && <NumberOfWinners>x {`${props.winner2_no}`}</NumberOfWinners>}
            <div>
              <RewardAmount>{props.moneySymbol} {props.winner2_amount}</RewardAmount>
              <div style={{ display: 'flex' }}>
                <AndImg src={and} />
                <RewardNote>{props.winner2_reward_note}</RewardNote>
              </div>
            </div>
          </Prize2Div>
          <Prize3Div>
          {props.winner3_no && <NumberOfWinners>x {`${props.winner3_no}`}</NumberOfWinners>}
            <Trophy src={Stage3} />
            <TrophyBottom src={trophy3_bottom} />
            <div>
              <RewardAmount>{props.moneySymbol}  {props.winner3_amount}</RewardAmount>
              <div style={{ display: 'flex' }}>
                <AndImg src={and} />
                <RewardNote>{props.winner3_reward_note}</RewardNote>
              </div>
            </div>
          </Prize3Div>
          {props?.extraWinners?.map((winner,index) => (
            <Prize3Div linearGradient={linearGradientArr[index]}>
              {props.winner3_no && <NumberOfWinners>x {`${winner.winner_no}`}</NumberOfWinners>}
              <Trophy src={trophySrcArr[index]} />
              <TrophyBottom src={trophy4_bottom} />
              <div>
                <RewardAmount>{props.moneySymbol}  {winner.winner_amount}</RewardAmount>
                <div style={{ display: 'flex' }}>
                  <AndImg src={and} />
                  <RewardNote>{winner.winner_reward_note}</RewardNote>
                </div>
              </div>
            </Prize3Div>
          ))}
         {imp_reward_notes && <div>
           <ul style={{ padding: '16px'}}>
            {imp_reward_notes.split('\n')?.map((impNote) => (
               <li style={{ display : 'flex'}}>
                  <MinWidthSetter>
                    <ImportantNoteIcon width={'34'} height={'34'} />
                  </MinWidthSetter>
                  <p style={{ 'white-space': 'pre-wrap'}}>{impNote}</p>
               </li>
            ))}
           </ul>
          </div>}
          <Prize4Div>
            <RewardNoteBottom src={trophy4_bottom} />
            <div style={{ display: 'flex' }}>
              <ul>
                {newRewardNotes.map((note) => (
                  <li>{note} </li>
                ))}
              </ul>
            </div>
          </Prize4Div>
          <BtnContainer>
            <Button
              onClick={() =>
                handleJoinContestBtn('contest_details', {
                  module_name: 'Enter into the Contest',
                  entity_type: 'contest',
                })
              }
            >
              Enter into the Contest
            </Button>
          </BtnContainer>
        </VerticalCenterItems>
      </CardContainer>
    </StageAndPrizeCardContainer>
  )
}
